import Reflux from 'reflux';
import EventData from 'shared/data/Event';

const async = { asyncResult: true },
  TeamEventListActions = Reflux.createActions({
    populate: {},
    getPage: async,
    page: {},
    notifyFilterChange: {}, //Used primarily to trigger spinner in SpinnerStore
  });

TeamEventListActions.getPage.listenAndPromise(EventData.getByTeamId);

export default TeamEventListActions;
